<template>
  <div class="withdrawList-box">
    <!--
    <div class="update-box">
      现金提现税率:
      <el-input placeholder="现金提现税率" size="small" class="param-input"></el-input>
      金币提现税率:
      <el-input placeholder="金币提现税率" size="small" class="param-input"></el-input>
      <el-button type="primary" size="small">修改</el-button>
    </div>
    -->
    <!--操作栏-->
    <div class="action-bar">
      订单时间:
      <el-select
        placeholder="请选择订单时间"
        size="small"
        clearable
        v-model="params.timeString"
        @change="getOrderList('status')"
      >
        <el-option
          v-for="item in orderTime"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option> </el-select
      >提现方式:
      <el-select
        v-model="params.payType"
        placeholder="提现方式"
        size="small"
        @change="getWithdrawList('status')"
      >
        <el-option
          v-for="item in type"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option> </el-select
      >提现状态:
      <el-select
        v-model="params.status"
        placeholder="提现状态"
        size="small"
        @change="getWithdrawList('status')"
      >
        <el-option
          v-for="item in status"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select
      >订单类型:
      <el-select
        v-model="params.productType"
        placeholder="订单类型"
        size="small"
        @change="getWithdrawList('status')"
      >
        <el-option
          v-for="item in productType"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input
        placeholder="请输入提现平台订单号"
        size="small"
        class="param-input"
        clearable
        @keyup.enter.native="getWithdrawList('status')"
        v-model="params.oid"
      ></el-input>
      <el-input
        placeholder="请输入订单ID"
        size="small"
        class="param-input"
        clearable
        @keyup.enter.native="getWithdrawList('status')"
        v-model="params.id"
      ></el-input>
      <el-input
        placeholder="请输入用户ID"
        size="small"
        class="param-input"
        clearable
        @keyup.enter.native="getWithdrawList('status')"
        v-model="params.uid"
      ></el-input>
      <el-input
        placeholder="请输入商区码"
        size="small"
        class="param-input"
        clearable
        @change="getWithdrawList('status')"
        v-model="params.districtCode"
      ></el-input>
      <el-input
        placeholder="请输入商区备注"
        size="small"
        class="param-input"
        clearable
        @change="getWithdrawList('status')"
        v-model="params.districtRemark"
      ></el-input>
      <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime"
      ></el-date-picker>
      是否过滤15分钟未审核用户:
      <el-select
        v-model="params.filterChecked"
        placeholder="请选择是否过滤"
        size="small"
        @change="getWithdrawList('status')">
        <el-option key="过滤" label="过滤" :value="true"></el-option>
        <el-option key="不过滤" label="不过滤" :value="false"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="getWithdrawList('status')"
        >搜索</el-button
      >
      <el-button type="primary" size="small" @click="withdrawalOrderExport" v-if="role!=='客服'"
        >导出</el-button
      >
    </div>
    <!-- 表格数据 -->
    <el-table
      :data="tableData"
      border
      tyle="width: 100%"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      height="550"
    >
      <el-table-column
        prop="id"
        label="ID"
        align="center"
        min-width="200"
        fixed
      >
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="oid"
        label="提现平台订单号"
        align="center"
        min-width="200"
        fixed
      >
        <template slot-scope="scope">
          <span>{{ scope.row.oid || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="districtCode"
        label="商区码"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.districtCode || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" align="center" min-width="120" fixed>
        <template slot-scope="scope">
          <span>{{ scope.row.uid || "未知" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="payType"
        label="提现方式"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.payType === 'alipay'">支付宝</span>
          <span v-else-if="scope.row.payType === 'bankcard'">银行卡</span>
          <span v-else-if="scope.row.payType === 'usdt'">USDT</span>
          <span v-else>未知方式</span>
        </template>
      </el-table-column>
      <el-table-column prop="usdtRate" label="USDT费率" align="center" min-width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.usdtRate || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="withdrawType"
        label="提现类型"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.withdrawType === 0">代理提现</span>
          <span v-else-if="scope.row.withdrawType === 1">金币提现</span>
          <span v-else-if="scope.row.withdrawType === 2">商区提现</span>
          <span v-else>未知账号</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="productType"
        label="订单类型"
        align="center"
        min-width="120"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{scope.row.productType | productType}}</span>
        </template>
      </el-table-column>
      <el-table-column label="提现账号" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.act || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="actName"
        label="提现姓名"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">{{
          scope.row.actName || "未知"
        }}</template>
      </el-table-column>
      <el-table-column
        prop="money"
        label="税前金额(元)"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">{{
          (scope.row.money / 100 || 0) | numFormat
        }}</template>
      </el-table-column>
      <el-table-column
        prop="payMoney"
        label="提现金额（元）"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">{{
          (scope.row.payMoney / 100 || "0") | numFormat
        }}</template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">{{
          (scope.row.status || "未知类型") | withdrawStatus
        }}</template>
      </el-table-column>
      <el-table-column
        prop="userIp"
        label="用户ip"
        align="center"
        min-width="160"
      />
      <el-table-column
        prop="statusDesc"
        label="状态说明"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">{{
          scope.row.statusDesc || "暂无说明"
        }}</template>
      </el-table-column>
      <el-table-column
        prop="districtRemark"
        label="商区备注"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">{{
          scope.row.districtRemark || "暂无备注"
        }}</template>
      </el-table-column>
      <el-table-column label="创建时间" align="center" min-width="160" fixed="right">
        <template slot-scope="scope">{{
          (scope.row.createdAt || "未知") | changeDate
        }}</template>
      </el-table-column>
      <el-table-column label="到账时间" align="center" min-width="160">
        <template slot-scope="scope">{{
          (scope.row.receivedAt || "未知") | changeDate
        }}</template>
      </el-table-column>

      <el-table-column label="回调时间" align="center" min-width="160">
        <template slot-scope="scope">{{
          (scope.row.successAt || "未知") | changeDate
        }}</template>
      </el-table-column>

      <el-table-column
        prop="operating"
        label="操作"
        align="center"
        min-width="160"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="showUsdtRatePop(scope.row)" v-if="scope.row.status === 1 && scope.row.payType == 'usdt'">线下打款</el-button>
          <el-tooltip
            class="item"
            effect="dark"
            content="通过"
            placement="top"
            v-if="scope.row.status === 1&& role!=='客服'"
          >
            <el-button
              type="success"
              class="el-icon-check"
              size="mini"
              @click="toExamine(scope.row.id, 1)"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="拒绝"
            placement="top"
            v-if="scope.row.status === 1"
          >
            <el-button
              type="danger"
              class="el-icon-close"
              size="mini"
              @click="openDialog(scope.row.id, 0)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 25]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 10"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--拒绝通过弹窗-->
    <el-dialog
      :title="'拒绝理由'"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-input
        type="textarea"
        :rows="3"
        placeholder="请输入内容"
        v-model="eParams.statusDesc"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="toExamine('', 0)"
          :loading="flag"
          size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :title="'线下打款'" :visible.sync="usdtRateVisible" width="400px" :before-close="rateClose" :close-on-click-modal="false">
      <el-form ref="form" label-width="100px">
        <el-form-item label="USDT费率">
          <el-input type="text" style="width: 200px;" placeholder="请输入USDT费率" v-model="usdtRate"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rateClose()" size="small">取 消</el-button>
        <el-button type="primary" @click="toExamine(offlineId, 1)" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseConfig from "@/utils/serverUrlConfig";
import { paramsFilter } from "@/utils/global";
import { sortEscape, changeTime } from "@/utils/global";
import API from "@/api";
export default {
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      time: "",
      loading: false,
      total: 0,
      // 订单时间选择
      orderTime: [
        {
          label: "创建时间",
          value: "createdAt"
        },
        {
          label: "到账时间",
          value: "receivedAt"
        },
        {
          label: "回调时间",
          value: "successAt"
        }
      ],
      // 订单类型
      productType: [
        { label: "全部", value: '' },
        { label: "站群订单", value: 0 },
        { label: "棋牌订单", value: 1 }
      ],
      // 审核接口参数
      eParams: {
        id: "",
        status: "",
        statusDesc: ""
      },
      flag: false,
      // 提现方式
      type: [
        {
          label: "全部",
          value: ""
        },
        {
          label: "支付宝",
          value: "alipay"
        },
        {
          label: "银行卡",
          value: "bankcard"
        }
      ],
      // 提现状态
      status: [
        {
          label: "全部",
          value: ""
        },
        {
          label: "未审核",
          value: 1
        },
        {
          label: "审核通过，转账中",
          value: 2
        },
        {
          label: "已拒绝",
          value: 3
        },
        {
          label: "未知错误",
          value: 4
        },
        {
          label: "提现成功",
          value: 5
        },
        {
          label: "提现失败",
          value: 6
        }
      ],
      // 请求订单列表参数
      params: {
        pageNumber: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        sortKey: "",
        sortValue: "",
        type: "",
        id: "",
        uid: "",
        oid: "",
        status: "",
        timeString: ""
      },
      role: "",
      usdtRateVisible: false,
      usdtRate: "",
    };
  },
  created() {
    this.getWithdrawList();
    this.getUserInfo();
  },
  filters: {
    productType(params) {
      switch (params) {
        case 0:
          return '站群订单';
        case 1:
          return '棋牌订单';
      }
    }
  },
  methods: {
    // 获取用户角色
    getUserInfo(){
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.role = userInfo.admin.role;
    },
    // 请求订单列表
    getWithdrawList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      API.getWithdrawList(this.params)
        .then(res => {
          if (res.code === 200 && res.data.orders) {
            this.tableData = res.data.orders;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 提现订单导出
    withdrawalOrderExport() {
      let params = paramsFilter(this.params);
      let str = "";
      for (let key in params) {
        if (key == "startTime" || key == "endTime") {
          params[key] = params[key].replace("+", "%2B");
        }
        str += key + "=" + params[key] + "&";
      }
      str = str.substring(0, str.length - 1);
      let url = baseConfig.baseServerUrl + "/export/withdrawOrder?" + str;
      window.location.href = url;
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size;
      this.getWithdrawList();
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getWithdrawList();
    },
    // 数据排序
    handleSortChange(column) {
      if (column.order) {
        this.params.sortValue = sortEscape(column.order);
        this.params.sortKey = column.prop;
      } else {
        this.params.sortValue = "";
        this.params.sortKey = "";
      }
      this.getWithdrawList();
    },
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0]) || "";
        this.params.endTime = changeTime(time[1]) || "";
      } else {
        this.params.startTime = "";
        this.params.endTime = "";
      }
      this.getWithdrawList("status");
    },
    // 审核提现
    toExamine(id, status) {
      if (status === 0 && !this.eParams.statusDesc) {
        this.$message.error("拒绝通过理由必须填写！");
        return false;
      }
      let param;
      if (status === 0) {
        // 拒绝
        param = this.eParams;
        this.flag = true;
      } else {
        // 通过
        this.flag = false;
        param = {
          id: id,
          type: status,
          statusDesc: "",
          usdtRate: this.usdtRate ? Number(this.usdtRate) : this.usdtRate
        };
      }
      API.WithdrawExamine(param).then(res => {
        if (res.code === 200) {
          this.$message({
            message: "审核成功！",
            type: "success"
          });
          this.getWithdrawList();
        } else {
          this.$message.error("审核失败！");
        }
        this.flag = false;
        this.handleClose();
      });
    },
    // 拒绝通过
    openDialog(id, status) {
      this.dialogVisible = true;
      this.eParams.id = id;
      this.eParams.status = status;
    },
    // 显示填写usdt费率弹窗
    showUsdtRatePop(row) {
      this.usdtRateVisible = true;
      this.offlineId = row.id;
    },
    // 弹窗关闭
    handleClose() {
      this.dialogVisible = false;
      this.usdtRateVisible = false;
      this.statusDesc = "";
    },
    rateClose() {
      this.usdtRateVisible = false;
      this.usdtRate = "";
    }
  }
};
</script>

<style lang="scss">
.withdrawList-box {
  .update-box {
    width: 100%;
    display: flex;
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 35px;
    color: #666;
    .el-input {
      width: 160px;
      margin-right: 10px;
      margin-left: 5px;
    }
    .el-button {
      margin-right: 10px;
      margin-left: 10px;
    }
  }
}
</style>
